import { render, staticRenderFns } from "./PositionCreate.vue?vue&type=template&id=3fde56c7&scoped=true&"
import script from "./PositionCreate.vue?vue&type=script&lang=js&"
export * from "./PositionCreate.vue?vue&type=script&lang=js&"
import style0 from "./PositionCreate.vue?vue&type=style&index=0&id=3fde56c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fde56c7",
  null
  
)

export default component.exports